export default __webpack_public_path__ + "static/media/world-green-grass.fafd814f.jpg";